import { render, staticRenderFns } from "./template.vue?vue&type=template&id=08e7e4f7&scoped=true"
import script from "./index.ts?vue&type=script&lang=ts&external"
export * from "./index.ts?vue&type=script&lang=ts&external"
import style0 from "./template.vue?vue&type=style&index=0&id=08e7e4f7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08e7e4f7",
  null
  
)

export default component.exports